
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'AppHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    titleAlign: {
      type: String,
      default: 'left',
      validator: v => ['left', 'center'].includes(v)
    },
    description: {
      type: String,
      default: null
    },
    seeAllReviewsUrl: {
      type: String,
      default: null
    },
    totalReviewsCount: {
      type: Number,
      default: 0
    },
    displayNewReviewButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      noticesCount: 0,
      hasNewNotice: false
    };
  },
  computed: {
    ...mapState(['api']),
    ...mapState('widget', ['widget']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('widget', ['device']),
    ...mapState('window', ['windowService']),
    seeAllReviewsLabel() {
      return this.widget.reviews_button_title || this.$t('see_all_reviews');
    }
  },
  created() {
    this.api.fetchNoticeSummary().then(({ data }) => {
      this.noticesCount = data.notices_count;
      this.hasNewNotice = data.has_new_notice;
    });
  },
  methods: {
    ...mapActions('dialog', ['openNewReviewPopup']),
    onClickNewReviewBtn() {
      this.openNewReviewPopup();
    },
    onClickSeeAllReviews() {
      this.windowService.redirectTo(this.seeAllReviewsUrl);
    }
  }
};
